import { Component, OnInit} from '@angular/core'
import { Constants } from 'app/shared/constant/constants';
import { ConstantsKey } from 'app/shared/constant/constants-keys';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'choose-profile',
  templateUrl: './choose-profile.component.html',
  styleUrls: ['./../persona-profile.scss'],
})
export class ChooseProfileComponent implements OnInit {
  
  public showLoader : boolean = false;
  public selectedProfile = "";
  public consumerId;
  public profileLocalObjects: any;
  public profileCurrentObj: any;
  constructor(public toast: ToastrService) {}

  ngOnInit() {
    this.consumerId = localStorage.getItem(ConstantsKey.CONSUMER_ID);
    this.profileLocalObjects = localStorage.getItem(ConstantsKey.USER_PERSONA_PROFILE);

    if(this.profileLocalObjects) {
      this.profileLocalObjects = JSON.parse(this.profileLocalObjects);
      this.profileCurrentObj = this.profileLocalObjects.filter(obj => obj.consId == this.consumerId);
      if(this.profileCurrentObj && this.profileCurrentObj.length == 1) {
        this.selectedProfile = this.profileCurrentObj[0]["currentPersonaPage"];
      } else {
        this.profileCurrentObj = [];
      }

    } else {
      this.profileLocalObjects = [];
      this.profileCurrentObj = [];
    }



  }

  setProfile() {
    if(this.selectedProfile != "") {
       if(this.profileCurrentObj && this.profileCurrentObj.length == 1) {
          this.profileCurrentObj[0]["currentPersonaPage"] = this.selectedProfile;
          let index = this.profileLocalObjects.findIndex( x => x.consId === this.consumerId );
          this.profileLocalObjects[index] = this.profileCurrentObj[0];
          localStorage.setItem(ConstantsKey.USER_PERSONA_PROFILE, JSON.stringify(this.profileLocalObjects));
       } else {
        this.profileCurrentObj = [{
            consId: this.consumerId,
            currentPersonaPage: this.selectedProfile
        }]; 
        this.profileLocalObjects.push(this.profileCurrentObj[0]);
        localStorage.setItem(ConstantsKey.USER_PERSONA_PROFILE, JSON.stringify(this.profileLocalObjects));
       }
    } else {
      this.toast.error("Please select Profile!");
    }
  }


  selectProfile(profile) {
    this.selectedProfile = profile;
  }

}
